export function payrollInvoiceDashboardItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/PayrollInvoice/dashboard/payroll-invoice-dashboard-item.html";
    const html = /*html*/`<apex-payroll-invoice-dashboard-container dashboard="dashboard">
        </apex-payroll-invoice-dashboard-container>`;
    $templateCache.put(path, html);
}

export function payrollInvoiceDashboardListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/PayrollInvoice/dashboard/payroll-invoice-dashboard-list-item.html";
    const html = /*html*/`
        <div ng-if="dashboard.count === 0">
            No payroll invoices have been posted.
        </div>
        <div ng-if="dashboard.count > 0">
            Please review any invoices that have been posted to your account.
        </div>
    `;
    $templateCache.put(path, html);
}
